export function getMediaCdnBase() {
  return (
    process.env.REACT_APP_MEDIA_CDN_BASE ?? process.env.MEDIA_CDN_BASE ?? ""
  );
}

function normalizeBase(base: string) {
  return base.replace(/\/+$/, "");
}

function normalizePath(path: string) {
  return path.replace(/^\/+/, "");
}

export function buildMediaUrl(path?: string) {
  if (!path) {
    return "";
  }

  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  const base = getMediaCdnBase();
  if (!base) {
    return `/${normalizePath(path)}`;
  }

  return `${normalizeBase(base)}/${normalizePath(path)}`;
}
